import client from '../../client';

const RADAR_LEADS = {
  getRadarLeadsCount() {
    return client.get('/radar_leads');
  },

  createRadarLead(params) {
    return client.post('/radar_leads', { radar_lead: params })
  }
}

export default RADAR_LEADS;
